export enum PathNavigationToolEvent {
  AlignmentMarkerMoved = 'AlignmentMarkerMoved',
  AlignmentNameChanged = 'AlignmentNameChanged',
  PathNavigationStatusChanged = 'PathNavigationStatusChanged',
  AlignmentPickingError = 'AlignmentPickingError',
}
